const familyTypesFilters = [
  {
    name: 'familyCode',
    label: 'familyCode',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'family',
    label: 'family',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'type',
    label: 'type',
    type: 'text',
    whereOperator: 'regexp',
  },
];

export default familyTypesFilters;
